import { platformStorageAttachedObjectReferenceSchema, platformStorageSha256Schema, platformStorageUploadIntentIdSchema, platformStorageUploadTransportSchema, } from '@crest/platform-contracts/storage';
import { z } from 'zod';
export const documentsProtectedObjectUploadsCapability = 'documents.protected-object-uploads.v1';
export const documentsProtectedObjectPurposeSchema = z.enum([
    'workforce-form-source',
    'completed-form',
    'signature',
    'supporting-attachment',
    'signed-policy-signature',
    'signed-policy-final-pdf',
]);
const protectedObjectFileNameSchema = z.string().trim().min(1).max(240).superRefine((value, context) => {
    if (value === '.' || value === '..' || /[\\/\u0000-\u001f\u007f]/.test(value)) {
        context.addIssue({ code: 'custom', message: 'Protected file name is not safe.' });
    }
});
export const documentsProtectedObjectUploadContentTypeSchema = z.enum([
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/heif',
]);
export const documentsInitiateProtectedObjectUploadSchema = z.strictObject({
    idempotencyKey: z.string().uuid(),
    resourceId: z.string().uuid(),
    purpose: documentsProtectedObjectPurposeSchema,
    targetMembershipId: z.string().uuid().nullable().default(null),
    originalFileName: protectedObjectFileNameSchema,
    contentType: documentsProtectedObjectUploadContentTypeSchema,
    sizeBytes: z.number().int().positive().max(50 * 1_024 * 1_024),
    sha256: platformStorageSha256Schema,
}).superRefine((value, context) => {
    const submissionPurpose = ['completed-form', 'signature', 'supporting-attachment']
        .includes(value.purpose);
    if (submissionPurpose !== (value.targetMembershipId !== null)) {
        context.addIssue({
            code: 'custom', path: ['targetMembershipId'],
            message: 'Only a protected employee-form submission requires its target membership.',
        });
    }
    const allowed = value.purpose === 'workforce-form-source'
        ? [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]
        : value.purpose === 'completed-form' || value.purpose === 'signed-policy-final-pdf'
            ? ['application/pdf']
            : value.purpose === 'signature' || value.purpose === 'signed-policy-signature'
                ? ['image/jpeg', 'image/png']
                : ['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
    if (!allowed.includes(value.contentType)) {
        context.addIssue({
            code: 'custom',
            path: ['contentType'],
            message: 'The protected file type does not match its intended use.',
        });
    }
});
export const documentsFinalizeProtectedObjectUploadSchema = z.strictObject({
    uploadIntentId: platformStorageUploadIntentIdSchema,
    resourceId: z.string().uuid(),
    purpose: documentsProtectedObjectPurposeSchema,
    targetMembershipId: z.string().uuid().nullable().default(null),
}).superRefine((value, context) => {
    const submissionPurpose = ['completed-form', 'signature', 'supporting-attachment']
        .includes(value.purpose);
    if (submissionPurpose !== (value.targetMembershipId !== null)) {
        context.addIssue({
            code: 'custom', path: ['targetMembershipId'],
            message: 'Only a protected employee-form submission requires its target membership.',
        });
    }
});
export const documentsProtectedObjectUploadAuthorizationResponseSchema = z.strictObject({
    data: z.strictObject({
        uploadIntentId: platformStorageUploadIntentIdSchema,
        transport: platformStorageUploadTransportSchema,
    }),
});
export const documentsProtectedObjectUploadFinalizationResponseSchema = z.strictObject({
    data: platformStorageAttachedObjectReferenceSchema,
});
//# sourceMappingURL=documents-protected-object-upload.contract.js.map